import { FC, lazy, useEffect, useState } from 'react';
import { UserPlatformIds } from 'src/apis/monolith/types';
import { PageSpinner } from 'src/components/spinner-container';
import { useOnChange } from 'src/hooks/use-on-change';
import { useGetOldUserIdDeprecated } from 'src/pages/settings/organisation/users/details/use-get-old-user-id';

const Page = lazy(() => import('./page'));

export const ApplyForAssignment: FC = () => {
  const [oldUserId, setOldUserId] = useState<UserPlatformIds | undefined>();
  const getOldUserId = useGetOldUserIdDeprecated();

  useEffect(() => {
    getOldUserId.execute();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useOnChange((response) => {
    if (!response) {
      return;
    }

    if (response.status === 200) {
      setOldUserId(response.data);
    }
  }, getOldUserId.response);

  if (!getOldUserId.response || !oldUserId) return <PageSpinner />;

  return <Page oldUserId={oldUserId} />;
};
